import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AGENDAMENTO_STATUS, IAgendamento } from '@app/modules/agendamento/model/agendamento.model';
import { colors } from '@app/modules/agendamento/model/colors_calendario';
import { Utils } from '@app/shared/helpers/utils';
import {
  convertTimeZone,
  validarAdicaoRaiz,
  verificarRotasDeAcessoRaiz
} from '@app/shared/utils';
import { TokenService } from 'viggo-sistemas-core-web';
import { AGENDAMENTO_TIPO } from '../../../modules/agendamento/model/agendamento.model';

export enum BUTTON_ACTION {
  DETAILS = 'DETAILS',
  CANCEL = 'CANCEL',
  EDIT = 'EDIT',
  START = 'START',
  CONCLUSION = 'CONCLUSION',
  PDF = 'PDF'
}

interface BUTTONS_CONFIG {
  icon: string;
  label: string;
  action: string;
  severity: string;
}

@Component({
  templateUrl: './dialog-list-agendamento.component.html',
  styleUrls: ['./dialog-list-agendamento.component.scss'],
  providers: [DatePipe]
})
export class DialogListAgendamentoComponent implements AfterViewInit {
  dataDialog: { agendamentos: IAgendamento[]; showBtnDialog: boolean };
  disableAnimation = true;
  cores = colors;
  buttons: BUTTONS_CONFIG[] = [];

  constructor(
    protected datePipe: DatePipe,
    protected tokenService: TokenService,
    protected matDialogRef: MatDialogRef<IAgendamento[]>,
    @Inject(MAT_DIALOG_DATA)
    data: { agendamentos: IAgendamento[]; showBtnDialog: boolean }
  ) {
    this.dataDialog = data;
  }

  ngAfterViewInit() {
    this.disableAnimation = false;
  }

  getDataHora(date: Date) {
    return convertTimeZone(date);
  }

  checkDisponibilidade(method: string, params = '', url: string) {
    const routesAcess = verificarRotasDeAcessoRaiz(
      this.tokenService.getRoutes(),
      url
    );
    return validarAdicaoRaiz(routesAcess, method, params, url);
  }

  getButtons(agendamento: IAgendamento) {
    switch (agendamento.status) {
      case AGENDAMENTO_STATUS.CANCELADA:
        if (this.checkDisponibilidade('GET', '', '/agendamentos/<id>')) {
          this.buttons = [
            {
              icon: 'pi pi-fw pi-eye',
              label: 'Visualizar',
              action: 'DETAILS',
              severity: 'primary'
            }
          ];
        }
        if (
          this.checkDisponibilidade(
            'GET',
            '',
            '/agendamentos/<id>/plano_terapeutico'
          ) &&
          agendamento.tipo === 'AVALIACAO'
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-print',
              label: 'Plano terapêutico',
              action: 'PDF',
              severity: 'primary'
            }
          ]);
        }
        break;
      case AGENDAMENTO_STATUS.EM_ANDAMENTO:
        if (this.checkDisponibilidade('PUT', '', '/agendamentos/<id>')) {
          this.buttons = [
            {
              icon: 'pi pi-fw pi-pencil',
              label: 'Editar',
              action: 'EDIT',
              severity: 'primary'
            }
          ];
        }
        if (
          this.checkDisponibilidade('PUT', '', '/agendamentos/<id>/reg_evento')
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-check-circle',
              label: 'Concluir',
              action: 'CONCLUSION',
              severity: 'success'
            },
            {
              icon: 'pi pi-fw pi-times-circle',
              label: 'Cancelar',
              action: 'CANCEL',
              severity: 'danger'
            }
          ]);
        }
        if (
          this.checkDisponibilidade(
            'GET',
            '',
            '/agendamentos/<id>/plano_terapeutico'
          ) &&
          agendamento.tipo === 'AVALIACAO'
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-print',
              label: 'Plano terapêutico',
              action: 'PDF',
              severity: 'primary'
            }
          ]);
        }
        break;
      case AGENDAMENTO_STATUS.CONCLUIDA:
        if (this.checkDisponibilidade('GET', '', '/agendamentos/<id>')) {
          this.buttons = [
            {
              icon: 'pi pi-fw pi-eye',
              label: 'Visualizar',
              action: 'DETAILS',
              severity: 'primary'
            }
          ];
        }
        if (
          this.checkDisponibilidade(
            'GET',
            '',
            '/agendamentos/<id>/plano_terapeutico'
          ) &&
          agendamento.tipo === 'AVALIACAO'
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-print',
              label: 'Plano terapêutico',
              action: 'PDF',
              severity: 'primary'
            }
          ]);
        }
        break;
      default:
        if (this.checkDisponibilidade('PUT', '', '/agendamentos/<id>')) {
          this.buttons = [
            {
              icon: 'pi pi-fw pi-pencil',
              label: 'Editar',
              action: 'EDIT',
              severity: 'primary'
            }
          ];
        }
        if (
          this.checkDisponibilidade('PUT', '', '/agendamentos/<id>/reg_evento')
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-play-circle',
              label: 'Iniciar atendimento',
              action: 'START',
              severity: 'help'
            },
            {
              icon: 'pi pi-fw pi-times-circle',
              label: 'Cancelar',
              action: 'CANCEL',
              severity: 'danger'
            }
          ]);
        }
        if (
          this.checkDisponibilidade(
            'GET',
            '',
            '/agendamentos/<id>/plano_terapeutico'
          ) &&
          agendamento.tipo === 'AVALIACAO'
        ) {
          this.buttons = this.buttons.concat([
            {
              icon: 'pi pi-fw pi-print',
              label: 'Plano terapêutico',
              action: 'PDF',
              severity: 'primary'
            }
          ]);
        }
        break;
    }
  }

  getTipo(tipo: AGENDAMENTO_TIPO) {
    return Utils.getEnumValue(tipo, AGENDAMENTO_TIPO);
  }
}
